module.exports = __webpack_public_path__ + "gamecode/img/dtmslg_favicon.png?4556327a";